/*
|
|--------------------------------------------------------------------------
| Barba Reload Scripts
|--------------------------------------------------------------------------
| Wordpress plugins often make use of scripts that need to run when
| specific pages are loaded. The script below runs all js files
| in wp_footer that is not in barbaNoReloadScripts
|
*/

Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container,newPageRawHTML) {

    let element = $(newPageRawHTML);

    reloadScripts(element);

});


//--------------------------------------------------------------------------
// Add js file names that you do not want to re run on page load
//--------------------------------------------------------------------------
let barbaNoReloadScripts = [
    'mainSrc.min.js',
    'main.min.js'
];

//--------------------------------------------------------------------------
// Add inline scripts used on each page to inline-scripts container
//--------------------------------------------------------------------------

$( document ).ready(function() {



    // Iterate through each <script> tag
    $('script').each(function(){

        //Added if check because wp-media was not running or load
        if(!$('.product-page')[0]){
            let scriptSrc = $(this).attr('src')

            // If script does not have src it is an inline script
            if(!scriptSrc){
                $(this).appendTo(".inline-scripts");
            }
        }

    });

});


function UrlNameMatch(url, nameArray){

    let bool = false;

    let fileName = url.replace(/^.*\//, ''); //Remove everything before file name
    fileName = fileName.replace(/\?.*/, ''); //Remove ? in case a version number is used


    if (nameArray.indexOf(fileName) < 0) bool = true;

    return bool;

}

function reloadScripts(element){


    //Clear inline scripts
    $( ".inline-scripts" ).empty();






    // Iterate through each <script> tag
    element.find('.wpFooter script').each(function(){

        let scriptSrc = $(this).attr('src');

        // if script has src then it's not an inline script
        if (scriptSrc) {
            //Run any script that is not included in the barbaNoReloadScripts array
            if ( UrlNameMatch(scriptSrc, barbaNoReloadScripts)) $.getScript(scriptSrc);

        } else if(!scriptSrc){
            // Append inline scripts to the .inline-scripts container
            $(this).appendTo(".inline-scripts");
        }

    });

}

